module.exports = __webpack_public_path__ + "img/frosinone-logo-icon.3c32d510.png";